// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ControlsTypes } from '@front/controls/UtilsClasses/FactoryConstants';
import { TerceraCheckBox } from '@front/controls/elements/TerceraCheckBox';
import InvestingCheckBoxTemplate from '../../TradingPlatformTemplates/InvestingCheckBoxTemplate.html';
class InvestingCheckBox extends TerceraCheckBox {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.InvestingCheckBox;
    }
}
TerceraCheckBox.extendWith(InvestingCheckBox, {
    template: InvestingCheckBoxTemplate,
    data: function () {
        return {
            checked: false,
            checkBoxCheckedState: 'none',
            text: '',
            tag: null
        };
    }
});
export { InvestingCheckBox };
